import styles from "./styles.module.scss";
import Link from "next/link";

export const CtaSimulacao = () => {
  return (
    <Link
      href={"/?utm_source=blog&utm_medium=banner&utm_campaign=fnz_content"}
      passHref
      className={styles.CTASimulacao}
    >
      Solicite seu empréstimo
      <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 32 14">
        <polyline
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="25 1 31 7 25 13"
        ></polyline>
        <line
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          x1="31"
          y1="7"
          x2="1"
          y2="7"
        ></line>
      </svg>
    </Link>
  );
};
